import { DataBean } from "../DataBean";

export class CreditRoleGroup extends DataBean {


    public async getCreditRoleGroupCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getCreditRoleGroupCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }


 
}